<template>
  <v-page page="home" title="Hello!">
  </v-page>
</template>

<script>
import VPage from '../layouts/Default'
import CurrentSession from '../mixins/CurrentSession'

export default {
  components: {
    VPage
  },
  mixins: [ CurrentSession ]
}
</script>
